/* eslint-disable @typescript-eslint/naming-convention */
/*
 * Copyright © 2021, Trimble Inc.
 * All rights reserved.
 *
 * The entire contents of this file is protected by U.S. and
 * International Copyright Laws. Unauthorized reproduction,
 * reverse-engineering, and distribution of all or any portion of
 * the code contained in this file is strictly prohibited and may
 * result in severe civil and criminal penalties and will be
 * prosecuted to the maximum extent possible under the law.
 *
 * CONFIDENTIALITY
 *
 * This source code and all resulting intermediate files, as well as the
 * application design, are confidential and proprietary trade secrets of
 * Trimble Inc.
 */

export enum AlertMonitor {
  ADIMPRESSIONS = 0,
  ADCLICKS = 1,
  SEARCH = 2,
  PRODUCTDOWNLOADS = 3,
  MODELDOWNLOADS = 4,
}
